import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ComboMunicipios } from './types';

export const INITIAL_STATE: ComboMunicipios = {
	status: 0,
	data: {
		processoId: '0',
		municipios: [],
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ComboMunicipios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.COMBO_MUNICIPIOS_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.COMBO_MUNICIPIOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.COMBO_MUNICIPIOS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
